/*
 * @Author: wuqinfa
 * @Date: 2024-02-18 14:54:50
 * @LastEditors: wuqinfa
 * @Description: 
 */
import { login, logout, changePassword, } from '@/services/account';

import * as cache from '@/utils/cache';

export default {
  namespace: 'login',
  state: {},
  effects: {
    *login({ payload }: any, { call }: any): any {
      const response = yield call(login, payload);

      cache.set('english-token', response.data);

      return response;
    },

    *logout(_: any, { call, put }: any): any {
      const response = yield call(logout);

      return response;
    },

    *changePassword({ payload }: any, { call }: any) {
      yield call(changePassword, payload);
    },
  },
  reducers: {},
};